import { ReactNode } from 'react';
import { connect } from 'react-redux';
import { QuoteType } from 'state/quotes/infos/infos.model';
import { cancelQuoteByWorkspaceThunk } from 'state/quotes/quotes.thunks';
import { getQuoteType } from 'state/quotes/selectors';
import { getStreamingSolvingModeByTabId } from 'state/quotes/streaming/streaming.selector';
import { getFormQuoteRequestStartingTimeInMillis, getFormQuoteResult } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

export interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;

  children: ReactNode;
}

export interface StateProps {
  quoteRequestStartingTimeInMillis: number;
  estimatedQuotingDurationInMillis?: number;
  solvingMode?: string;
  quoteType?: QuoteType;
  pricedOn: string;
}

export interface DispatchProps {
  onQuoteCancelled(): void;
}

export type StreamingProps = StateProps & OwnProps & DispatchProps;

const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const quoteResult = getFormQuoteResult(state, workspaceType, tabId);
  const quoteRequestTimeInMillis = getFormQuoteRequestStartingTimeInMillis(state, workspaceType, tabId)!;
  return {
    quoteRequestStartingTimeInMillis: quoteRequestTimeInMillis,
    estimatedQuotingDurationInMillis: quoteResult?.estimatedQuotingDurationInMillis!,
    solvingMode: getStreamingSolvingModeByTabId(state, tabId),
    quoteType: getQuoteType(state, quoteResult?.quoteId),
    pricedOn: new Date(quoteRequestTimeInMillis).toISOString(),
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId, workspaceType }: OwnProps): DispatchProps => ({
  onQuoteCancelled() {
    dispatch(cancelQuoteByWorkspaceThunk(tabId, workspaceType));
  },
});

export const connectStream = connect(mapStateToProps, mapDispatchToProps);
